<template>
  <page-template>
    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :play-button-function="callModalSignupConfirm"
           :disabled-modify-button="true"
           :disabled-delete-button="true"
           :disabled-play-button="true"/>
  </page-template>
</template>

<script>
import Vue from 'vue';

import config from './Config';

import UserManagementCustomActionComponent from './custom-action-component/UserManagementCustomActionComponent';
import CommonBoardItems from '../CommonBoardItems';

Vue.component('UserManagementCustomActionComponent', UserManagementCustomActionComponent);

export default {
  name: 'BoardUserManagement',
  methods: {
    callModalSignupConfirm(rowData) {
      this.$modal.changeToComponent(this.$modal.modalType.SignupConfirm, rowData);
    },
  },
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/user-management/BoardUserManagement.vue